import React, { useCallback, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { getServiceProviderInformationAction, updateServiceProviderInformationAction } from "../../../../state/usecase/admin/service_provider/actions";
import { useAppDispatch } from "../../../../state/store";
import { ServiceProviderId } from "../../../../domain/service_provider/ServiceProviderId";
import { ServiceProviderName } from "../../../../domain/service_provider/ServiceProviderName";
import { ServiceProviderSpId } from "../../../../domain/service_provider/ServiceProviderSpId";
import { ServiceProviderSharedPassword } from "../../../../domain/service_provider/ServiceProviderSharedPassword";
import { Loading } from "../../common/Loading";
import { AdminServiceProviderEditComponent } from "./AdminServiceProviderEditComponent";
import { useServiceProviderInformation } from "../../../hooks/admin/service_provider/useServiceProviderInformation";
import { useInput } from "../../../hooks/common/useInput";

type AdminServiceProviderUpdatePagePathParams = {
    serviceProviderId: string
};

export function AdminServiceProviderUpdatePage() {
    const [serviceProviderName, setServiceProviderName, handleServiceProviderNameChanged] = useInput("");

    const [serviceProviderSpId, setServiceProviderSpId, handleSetServiceProviderSpIdChanged] = useInput("");

    const [serviceProviderSharedPassword, setServiceProviderSharedPassword, handleSetServiceProviderSharedPasswordChanged] = useInput("");

    const dispatch = useAppDispatch();

    const params = useParams<AdminServiceProviderUpdatePagePathParams>();

    const serviceProviderId = useMemo<ServiceProviderId | null>(() => {
        if (!params.serviceProviderId) return null;
        return ServiceProviderId.fromString(params.serviceProviderId);
    }, [params.serviceProviderId]);

    const serviceProviderInformation = useServiceProviderInformation();

    useEffect(() => {
        if (!serviceProviderId) return;
        dispatch(getServiceProviderInformationAction(serviceProviderId));
    }, [dispatch, serviceProviderId]);

    useEffect(() => {
        setServiceProviderName(serviceProviderInformation.name.value);
        setServiceProviderSpId(serviceProviderInformation.spId.value);
        setServiceProviderSharedPassword(serviceProviderInformation.sharedPassword.value);
    }, [
        setServiceProviderName,
        setServiceProviderSpId,
        setServiceProviderSharedPassword,
        serviceProviderInformation.name.value,
        serviceProviderInformation.spId.value,
        serviceProviderInformation.sharedPassword.value
    ]);

    const handleServiceProviderInformationUpdateClicked = useCallback(() => {
        if (!serviceProviderId) return;
        dispatch(updateServiceProviderInformationAction({
            serviceProviderId: serviceProviderId,
            serviceProviderName: ServiceProviderName.fromString(serviceProviderName),
            serviceProviderSpId: ServiceProviderSpId.fromString(serviceProviderSpId),
            serviceProviderSharedPassword: ServiceProviderSharedPassword.fromString(serviceProviderSharedPassword)
        }));
    }, [dispatch, serviceProviderId, serviceProviderName, serviceProviderSharedPassword, serviceProviderSpId]);

    // レスポンス取得中
    if (!serviceProviderInformation) return <Loading/>;

    return (
        <AdminServiceProviderEditComponent
            category="更新"
            serviceProviderName={serviceProviderName}
            serviceProviderSpId={serviceProviderSpId}
            serviceProviderSharedPassword={serviceProviderSharedPassword}
            handleServiceProviderNameChanged={handleServiceProviderNameChanged}
            handleSetServiceProviderSpIdChanged={handleSetServiceProviderSpIdChanged}
            handleSetServiceProviderSharedPasswordChanged={handleSetServiceProviderSharedPasswordChanged}
            handleServiceProviderUpsertClicked={handleServiceProviderInformationUpdateClicked}
        />
    );
}
